module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_pc_002-c2cf0cc0313553a3ee23bdcf41385c85.png";